import { render, staticRenderFns } from "./event-subscriptions.vue?vue&type=template&id=29152466&"
import script from "./event-subscriptions.vue?vue&type=script&lang=ts&"
export * from "./event-subscriptions.vue?vue&type=script&lang=ts&"
import style0 from "./event-subscriptions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports